import {
  Collapse as MuiCollapse,
  type CollapseProps as MuiCollapseProps,
  Fade as MuiFade,
  type FadeProps as MuiFadeProps,
  Grow as MuiGrow,
  type GrowProps as MuiGrowProps,
  Slide as MuiSlide,
  type SlideProps as MuiSlideProps,
  Zoom as MuiZoom,
  type ZoomProps as MuiZoomProps
} from "@mui/material";

export type FadeProps = MuiFadeProps;
export type CollapseProps = MuiCollapseProps;
export type GrowProps = MuiGrowProps;
export type SlideProps = MuiSlideProps;
export type ZoomProps = MuiZoomProps;

export const Fade = MuiFade;
export const Collapse = MuiCollapse;
export const Grow = MuiGrow;
export const Slide = MuiSlide;
export const Zoom = MuiZoom;
